<div class="left-side-controllers">
  <mat-icon class="intosite-logo-icon" svgIcon="intosite.logo.icon"></mat-icon>
  @if (siteName !== 'No Site Selected') {
    <div class="siteNameContainer"><div class="siteName">{{siteName}}</div></div>
  } @else {
    <div class="siteNameContainer">
      <div class="siteName noSiteSelected">{{siteName}}</div>
    </div>
  }
</div>
<div class="right-side-controllers">
  <mat-icon class="siemens-logo" svgIcon="app.siemens-logo"></mat-icon>
</div>


